import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import { LicenseManager } from "ag-grid-enterprise/main";
LicenseManager.setLicenseKey(
  "Internal_Displacement_Monitoring_Centre_Helix" +
    "_1Devs10_April_2019__MTU1NDg1MDgwMDAwMA" +
    "==deb3053842a8533f31c168d4a39d0cca"
);
